import type { IConfigurationForm } from './IConfigurationForm';
import { PageFormRow, PageFormInput } from '@echotex/business-modules';
import { Dropdown } from '@core-web/ui';
import * as S from './ConfigurationForm.styled';
import { StaticMenuDropDownData, EnvironmentDropDownData } from '../../mockData';

export const ConfigurationForm = (props: IConfigurationForm): JSX.Element => {
  const { schema } = props;
  const { fieldLabels, isRequireds, fieldTitles, placeHolders } = schema;

  return (
    <S.ConfigurationFormWrapper>
      <PageFormRow>
        <PageFormInput label={fieldLabels.staticMenu} required={isRequireds.staticMenu}>
          <Dropdown
            name={fieldTitles.staticMenu}
            preFetchedOptions={StaticMenuDropDownData}
            placeHolder={placeHolders.staticMenu}
          />
        </PageFormInput>
        <PageFormInput label={fieldLabels.environment} required={isRequireds.environment}>
          <Dropdown
            name={fieldTitles.environment}
            preFetchedOptions={EnvironmentDropDownData}
            placeHolder={placeHolders.environment}
          />
        </PageFormInput>
      </PageFormRow>
    </S.ConfigurationFormWrapper>
  );
};
